
import { Component, Vue } from 'vue-property-decorator'
import { redirectToRouteOnce } from '@/service/navigation'
import { normalizeError } from '@/service/error'

@Component({})
export default class AuthCheckMixin extends Vue {
    async handleCallback (callable: () => Promise<void>): Promise<void> {
        try {
            await callable()
        } catch (err) {
            if (normalizeError(err).isAuthError) {
                await redirectToRouteOnce(this.$router, '/')
            }
        }
    }
}
